import { useTranslation } from 'react-i18next';
import { REASON_FOR_OPEN } from '../consts';

interface AccountOpeningReasonListItemProps {
  reason: REASON_FOR_OPEN;
  onClickItem: (reason: REASON_FOR_OPEN, title: string) => void;
}
export const AccountOpeningReasonListItem = ({
  reason,
  onClickItem,
}: AccountOpeningReasonListItemProps) => {
  const { t } = useTranslation();

  const title = t(`pages.accountOpeningReason.reasonForOpen.${reason}`);

  return (
    <li
      data-testid={reason}
      onClick={() => onClickItem(reason, title)}
      className='text-sm rounded-xl border-small p-[14px] border-surface-primary-bw-04 hover:border-text-brand-primary cursor shadow-reasonListItem cursor-pointer'>
      {title}
    </li>
  );
};
